import React from 'react';
import { Link } from 'react-router-dom';
import { FiLogOut, FiMenu, FiUser } from 'react-icons/fi';
import { useSelector } from 'react-redux';

import Dropdowns from '../../dropdown/Dropdown';
import './Header.css';

function Header({ toggleSidebar, onLogout, currentRoute }) {
  const profile = useSelector((state) => state.user.profile);
  const profileName = [profile?.firstname, profile?.lastname].filter(Boolean).join(' ') || profile?.email || 'Workspace User';

  return (
    <header className="workspace-header">
      <div className="workspace-header__leading">
        <button className="workspace-header__menu" onClick={toggleSidebar} aria-label="Open navigation">
          <FiMenu />
        </button>
        <div>
          <span className="workspace-header__eyebrow">{currentRoute?.section || 'Workspace'}</span>
          <strong>{currentRoute?.label || 'Accounting Workspace'}</strong>
        </div>
      </div>

      <Dropdowns className="workspace-header__filters" />

      <div className="workspace-header__actions">
        <div className="workspace-header__identity">
          <span>Signed in as</span>
          <strong>{profileName}</strong>
        </div>
        <Link to="/profile" className="workspace-header__link">
          <FiUser />
          <span>Profile</span>
        </Link>
        <button className="workspace-header__logout" onClick={onLogout}>
          <FiLogOut />
          <span>Logout</span>
        </button>
      </div>
    </header>
  );
}

export default Header;
